export enum TimezoneEnum {
  Local = 'l',
  Universal = 'z'
}
